"use strict";import{tag as r}from"../custom-tag.js";export function liveEventIcon({height:a=16,width:l=16,hidden:t=!1,title:e="Live event"}={}){return r`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${t?"true":"false"}"
      role="img"
      aria-label="${e}"
    >
      <path
        fill="currentColor"
        d="M20.404 17.625a.826.826 0 0 0 .825-.825V6.6a.826.826 0 0 0-.825-.825h-16.8a.826.826 0 0 0-.825.825v10.2a.826.826 0 0 0 .825.825h8.175v.75H7.804v.45h8.4v-.45H12.23v-.75zm-16.8-.45a.375.375 0 0 1-.375-.375V6.6a.375.375 0 0 1 .375-.375h16.8a.375.375 0 0 1 .375.375v10.2a.376.376 0 0 1-.375.375z"
      />
      <path
        fill="currentColor"
        d="m14.323 10.926-.27-.361c-.798.595-1.68 1.758-2.317 2.69.307-1.028.784-2.142.79-2.158l-.413-.178c-.023.054-.339.794-.624 1.632-.695.681-1.482 1.224-1.673 1.139-.054-.024-.06-.047-.063-.06-.073-.273.524-1.09.78-1.44a.225.225 0 0 0-.318-.311c-1.83 1.388-4.08 2.623-4.58 2.231-.09-.384.974-2.368 1.614-3.559q.66-1.122 1.14-2.334l-.436-.113q-.47 1.156-1.1 2.235c-1.476 2.746-1.906 3.721-1.543 4.084a.83.83 0 0 0 .586.172c.58 0 1.657-.3 3.593-1.634-.15.233-.21.511-.171.785a.53.53 0 0 0 .317.356c.398.175 1.062-.262 1.593-.705a5.5 5.5 0 0 0-.192.987.225.225 0 0 0 .415.134c.502-.81 1.785-2.783 2.872-3.592m1.025 1.899c-.378.333-1.38 1.22-1.646.988a.62.62 0 0 1-.142-.651c.545.145 1.142-.36 1.315-.522.141-.132.595-.593.5-.968a.4.4 0 0 0-.293-.284c-.509-.135-1.381.557-1.766 1.219-.337.58-.314 1.135.077 1.532.114.1.26.155.411.152.562 0 1.283-.636 1.841-1.129.142-.124.261-.23.347-.294l-.27-.36a7 7 0 0 0-.374.317m-.415-1.005a1.55 1.55 0 0 1-.506.613 1.2 1.2 0 0 1-.662.304c.353-.539.942-.915 1.168-.917m2.003 1.236.44.096c.237-1.093 1.995-3.642 2.013-3.667l-.37-.256c-.074.107-1.827 2.648-2.083 3.827"
      />
      <path
        fill="currentColor"
        d="M11.06 10.744a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m5.744 3.956a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6"
      />
    </svg>
  `}
//# sourceMappingURL=liveEvent.js.map
